import { Injectable } from '@angular/core';
import { bcAuthEvents } from 'common/common/constants/auth-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';

@Injectable()
export class LogoutSubscriber {
  constructor(public RxEmitter: RxEmitter) {
  }

  subscribe(callback) {
    return this.RxEmitter.subscribe(bcAuthEvents.logoutSuccess, callback);
  }
}
